const OPTION_LABELS = ["a)", "b)", "c)", "d)", "e)", "f)", "g)", "h)", "i)", "j)", "k)", "l)"];

/**
 * Convierte la respuesta del API (quiz) al formato usado en la UI.
 * @param {object} quizData - Quiz devuelto por GET /api/quiz/:id
 * @param {string} quizId - Id del quiz
 * @returns {object|null} { quizId, title, options } o null si no hay opciones
 */
export function mapQuizToQuestion(quizData, quizId) {
	if (!quizData) return null;
	const opts = quizData.options;
	let optionsArray = Array.isArray(opts)
		? opts
		: opts && typeof opts === "object"
		? Object.keys(opts)
				.sort((a, b) => Number(a) - Number(b))
				.map((k) => opts[k])
		: [];
	optionsArray = optionsArray.filter((o) => o && (o.text != null || o.optionText != null));
	if (optionsArray.length === 0) return null;
	// Ordenar por id numérico para que a)=1, b)=2, etc. coincida con el backoffice
	optionsArray = [...optionsArray].sort((a, b) => (Number(a?.id) ?? 0) - (Number(b?.id) ?? 0));
	const title = (quizData.screenTitle && quizData.screenTitle.trim()) ? quizData.screenTitle.trim() : (quizData.fullName ?? "");
	const legend = quizData.legend != null ? String(quizData.legend) : "";
	const options = optionsArray.map((o, i) => ({
		id: OPTION_LABELS[i] ?? String(i + 1),
		text: o.text != null ? String(o.text) : (o.optionText != null ? String(o.optionText) : ""),
		selected: false,
		correct: Boolean(o.correct),
	}));
	const resultExplanation = quizData.resultExplanation != null ? String(quizData.resultExplanation) : "";
	return { quizId, title, options, resultExplanation, legend };
}
